import Vue from "vue";
import moment from "moment";
import CXMApiClient from "../CXMApiClient";

function initialState() {
  return {
    ManageWorkflowModalInfo: {
      ShowModal: false,
      ContactId: null,
      ContactName: null,
      PlatformId: null
    },
    OnDemandWorkflowModalInfo: {
      ShowModal: false,
      ContactId: null,
      PlatformId: null
    }
  };
}

const state = initialState();

const actions = {
  async getActiveWorkflowsForContact(context, contactId) {
    return await Vue.http.post(`pando/pandox/activeWorkflow?contactId=${contactId}`);
  },
  async getHistoricalWorkflowsForContact(context, contactId) {
    return await Vue.http.post(`pando/pandox/historicalWorkflow?contactId=${contactId}`);
  },
  updateManageWorkflowModalInfo: function (context, data) {
    context.commit("updateManageWorkflowModalInfo", data);
  },
  async stopActiveWorkflow(context, workflowId) {
    let response = await Vue.http.post(
      "pando/pandox/activeWorkflow/stop?workflowId=" + workflowId
    );
    return response && response.data ? response.data : null;
  },
  async reassignTaskUser(context, request) {
    let response = await Vue.http.post("pando/pandox/task/reassign", request);
    return response && response.data ? response.data : null;
  },
  async cancelTask(context, request) {
    let response = await Vue.http.post("pando/pandox/task/cancel", request);
    return response && response.data ? response.data : null;
  },
  async completeTask(context, request) {
    let response = await Vue.http.post("pando/pandox/task/complete", request);
    return response && response.data ? response.data : null;
  },
  async getWorkflows(context, request) {
    let response = await new CXMApiClient().ProcessRequest(
      "POST",
      "/api/TriggerSet/workflows",
      request
    );
    return response && response.data ? response.data.data : null;
  },
  async getWorkflowHistory(context, request) {
    let response = await new CXMApiClient().ProcessRequest(
      "POST",
      "/api/TriggerSet/task_history",
      request
    );
    return response && response.data ? response.data : null;
  },
  updateOnDemandWorkflowModalInfo(context, data) {
    context.commit("updateOnDemandWorkflowModalInfo", data);
  },
  async getOnDemandWorkflows(context, request) {
    try {
      let response = await new CXMApiClient().ProcessRequest(
        "POST",
        "/api/TriggerSet/on_demand_workflows",
        request
      );
      return response && response.data ? response.data.data : null;
    } catch (err) {
      return null;
    }
  },
  async startOnDemandWorkflow(context, request) {
    let response = await new CXMApiClient().ProcessRequest(
      "POST",
      "/api/Lead/adhoc/create",
      request
    );
    return response ? response.data : null;
  }
};

const mutations = {
  updateManageWorkflowModalInfo: function (state, data) {
    state.ManageWorkflowModalInfo.ShowModal = data.ShowModal;
    state.ManageWorkflowModalInfo.ContactId = data.ContactId;
    state.ManageWorkflowModalInfo.ContactName = data.ContactName;
    state.ManageWorkflowModalInfo.PlatformId = data.PlatformId;
  },
  updateOnDemandWorkflowModalInfo(state, data) {
    state.OnDemandWorkflowModalInfo.ShowModal = data.ShowModal;
    state.OnDemandWorkflowModalInfo.ContactId = data.ContactId;
    state.OnDemandWorkflowModalInfo.PlatformId = data.PlatformId;
  }
};

const getters = {};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/Workflows.js